import React from 'react';

export default function StockAlertBar() {
  return (
    <div className="bg-gold-500 border-b border-gold-600">
      <div className="container mx-auto px-4 lg:px-8 py-2 sm:py-3">
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 text-center">
          <span className="hidden xs:inline text-xs sm:text-base lg:text-lg font-bold text-gray-950">
            Fresh Stock Ready in Karachi & Kampala
          </span>
          <span className="xs:hidden text-xs font-bold text-gray-950">
            Stock Ready
          </span>
          <a href="https://wa.me/447716089293" target="_blank" rel="noopener noreferrer" className="text-gray-950 underline font-semibold hover:text-gray-800 transition text-xs sm:text-base">
            Order Now &rarr;
          </a>
        </div>
      </div>
    </div>
  );
}
